/**
 * NotificationService
 * 
 * @param {Object} params - Parameters to configure the notification.
 * @param {string} params.type - The type of notification. Can be one of the following values:
 *    - "success": Indicates a successful operation.
 *    - "info": Provides general information.
 *    - "warning": Indicates a warning or alert.
 *    - "error": Indicates an error or failure.
 *    Default value: "info".
 * @param {string} params.message - The title of the notification. Default value: "Default Title".
 * @param {string} params.description - The description of the notification. Default value: "This is the default description.".
 */

import { notification } from "antd";

const NotificationService = ({ 
  type = "info", 
  message = "Default Title", 
  description = "This is the default description." 
}) => {
  notification[type]({
    message,
    description,
  });
};

export default NotificationService;
